"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagSV = function FlagSV(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-32.55H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.63,42.23A30.89,30.89,0,0,1-12-8.57l1.35,1.14A29.13,29.13,0,0,0,11.63,40.46Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.33,33.11a6,6,0,0,0-.66,2.48,7.42,7.42,0,0,0-1.12-.68,7.77,7.77,0,0,0-.13,3.68,5.8,5.8,0,0,0-3.09,1.68A8.12,8.12,0,0,0-3.29,41a6.2,6.2,0,0,0-1.92,2.28c8.67,4.33,12.81-1.71,13-2A14.39,14.39,0,0,0,.33,33.11Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.79,41.3s0,0,0,0v0Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-7.67,27.33a5.79,5.79,0,0,0-1.47,1.85,6.44,6.44,0,0,0-.69-1,7.26,7.26,0,0,0-1.46,3.05,5.35,5.35,0,0,0-3.22.29,7.84,7.84,0,0,0,.9,1.13,5.65,5.65,0,0,0-2.45,1.22C-10.34,40.71-4.63,37.13-4.38,37a13.19,13.19,0,0,0-3.29-9.64Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-4.38,37v0l0-.06,0,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-12.64,19.78a5.16,5.16,0,0,0-1.88,1,6.62,6.62,0,0,0-.21-1.06,6.41,6.41,0,0,0-2.33,2,4.84,4.84,0,0,0-2.75-.95A6.46,6.46,0,0,0-19.49,22a5,5,0,0,0-2.46.1c2.16,7.72,8.18,6.9,8.45,6.85a11.85,11.85,0,0,0,.86-9.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-13.5,28.92l0,0,0,0s0,0,0,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-14.6,11.18a5.12,5.12,0,0,0-1.92.62,5,5,0,0,0,.05-1A7,7,0,0,0-19,12.27a3.94,3.94,0,0,0-2.26-1.16,5.71,5.71,0,0,0,0,1.13A4.9,4.9,0,0,0-23.51,12c.18,7,5.78,7,6,7a10.8,10.8,0,0,0,2.88-7.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-17.48,19s0,0,0,0l.05,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-13.95,4.05a4.81,4.81,0,0,0-1.77,0,4.5,4.5,0,0,0,.29-.78,6.14,6.14,0,0,0-2.5.54,3.51,3.51,0,0,0-1.6-1.56,4.85,4.85,0,0,0-.29,1,4.3,4.3,0,0,0-1.83-.76c-1.64,5.88,3,7.35,3.26,7.41a9.49,9.49,0,0,0,4.44-5.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-18.38,9.87s0,0,0,0l.05,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-17.66-4.61S-19.27-.42-16.79,2a8.57,8.57,0,0,0,4.84-4.32l-1.36-.26-.7-2.1-2.31,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-13.16-11.35s-2.51,3.72-.64,6.65A8.55,8.55,0,0,0-8.11-7.82l-1.27-.56-.2-2.2-2.49.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,42.23V40.46A29.13,29.13,0,0,0,34.25-7.43L35.6-8.57A30.9,30.9,0,0,1,12,42.23Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.27,33.11a6,6,0,0,1,.66,2.48,7.42,7.42,0,0,1,1.12-.68,7.77,7.77,0,0,1,.13,3.68,5.84,5.84,0,0,1,3.09,1.68,8.12,8.12,0,0,1-1.38.73,6.33,6.33,0,0,1,1.92,2.28c-8.67,4.33-12.82-1.71-13-2a14.36,14.36,0,0,1,7.46-8.19Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.81,41.3l0,0v-.06l0,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.27,27.33a5.63,5.63,0,0,1,1.46,1.85,7.31,7.31,0,0,1,.7-1,7.14,7.14,0,0,1,1.46,3.05,5.32,5.32,0,0,1,3.21.29,7.27,7.27,0,0,1-.89,1.13,5.73,5.73,0,0,1,2.45,1.22C33.94,40.71,28.23,37.13,28,37a13.19,13.19,0,0,1,3.29-9.64Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28,37v0L28,37l0,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M36.23,19.78a5,5,0,0,1,1.89,1,6.62,6.62,0,0,1,.21-1.06,6.41,6.41,0,0,1,2.33,2,4.84,4.84,0,0,1,2.75-.95A6.46,6.46,0,0,1,43.09,22a5.07,5.07,0,0,1,2.46.1c-2.17,7.72-8.18,6.9-8.45,6.85a11.88,11.88,0,0,1-.87-9.13Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M37.1,28.92l0,0,0,0s0,0,0,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.2,11.18a5.12,5.12,0,0,1,1.92.62,5,5,0,0,1,0-1,7,7,0,0,1,2.54,1.42,3.94,3.94,0,0,1,2.26-1.16,5.71,5.71,0,0,1,0,1.13A4.9,4.9,0,0,1,47.11,12c-.18,7-5.79,7-6,7a10.82,10.82,0,0,1-2.87-7.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M41.07,19s0,0,0,0l-.05,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M37.55,4.05a4.81,4.81,0,0,1,1.77,0A3.81,3.81,0,0,1,39,3.29a6.17,6.17,0,0,1,2.5.54,3.51,3.51,0,0,1,1.6-1.56,4.85,4.85,0,0,1,.29,1,4.29,4.29,0,0,1,1.82-.76c1.65,5.88-3,7.35-3.26,7.41a9.5,9.5,0,0,1-4.43-5.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M42,9.87l0,0,0,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M41.27-4.61S42.87-.42,40.38,2a8.54,8.54,0,0,1-4.83-4.32l1.36-.26.69-2.1,2.33,1Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M36.76-11.35s2.51,3.72.64,6.65a8.55,8.55,0,0,1-5.69-3.12L33-8.38l.2-2.2,2.49.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#50af69"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,23.66,9.07,27.75A1.76,1.76,0,0,0,9.29,30l2.51,2.5L14.31,30a1.77,1.77,0,0,0,.22-2.23Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13,27.75,11.8,23.66l-1.16,4.09A3.74,3.74,0,0,0,10.73,30l1.07,2.5L12.87,30A3.74,3.74,0,0,0,13,27.75Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-13V-24A24.63,24.63,0,0,0,8.27-9.15",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-7-12.94a27.46,27.46,0,0,0,1.46,26c0,.06,8.66-13.9,8.66-13.9L-7-12.94",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-.62,5.23A17.68,17.68,0,0,1-.57-5.22l-3.75-4.5C-7.4-1.41-6.12,4.73-3,9.13l2.42-3.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3-.07a.88.88,0,0,1-.69-.34L-8.79-14.65a.87.87,0,0,1,.15-1.23.89.89,0,0,1,1.24.15L3.67-1.5A.89.89,0,0,1,3.52-.26.9.9,0,0,1,3-.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-14.68.74C-18.22,36.05,10,27.22,11.8,23.69L-5.86,14.86-2.32,7.8-14.68.74",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-6.15,4.8l-4.92-2.95C-12.18,22.83-1,26.33,7.3,25.29.59,24.39-6.1,19.44-6.15,4.8Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-2.32,8.68a.88.88,0,0,1-.47-.13L-16.91-.28a.88.88,0,0,1-.29-1.21A.87.87,0,0,1-16-1.77L-1.86,7.05a.89.89,0,0,1,.29,1.22.88.88,0,0,1-.75.41Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M30.6-13a27.48,27.48,0,0,1-1.46,26S20.48-.84,20.48-.84L30.6-13",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.22,5.19a17.61,17.61,0,0,0-.06-10.45l3.76-4.5C31-1.45,29.73,4.69,26.64,9.09c-.76-1.21-1.6-2.57-2.42-3.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.62-.11a.83.83,0,0,1-.53-.18.88.88,0,0,1-.16-1.24L31-15.76a.88.88,0,0,1,1.24-.16.89.89,0,0,1,.15,1.24L21.32-.45a.85.85,0,0,1-.7.34Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.28.7C41.81,36,13.57,27.19,11.8,23.66l17.66-8.83L25.93,7.76,38.28.7",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.75,4.76l4.92-2.95c1.1,21-10.1,24.48-18.37,23.44,6.7-.9,13.4-5.85,13.45-20.49Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.93,8.65a.87.87,0,0,1-.75-.42A.88.88,0,0,1,25.46,7L39.58-1.81a.88.88,0,0,1,1.22.28.9.9,0,0,1-.28,1.22L26.39,8.51a.86.86,0,0,1-.46.14Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.86,2.47A7.06,7.06,0,1,1,11.8-4.59a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe6e6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.33,2.47A3.53,3.53,0,1,1,11.8-1.06a3.53,3.53,0,0,1,3.53,3.53Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,14a.88.88,0,0,1-.88-.89V2.47a.88.88,0,0,1,1.76,0V13.06a.88.88,0,0,1-.88.89Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M35.93,23.51h-47.3L-5.86,13H29.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#5aa0e6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.23,15H25.54l-3.83-3.83a1.65,1.65,0,0,0-.64-.4l-1.33-.44a1.65,1.65,0,0,0-1.43.19l-4.25,2.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb750"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.05,15.64H23.73l-4.56-4.57a2,2,0,0,0-.77-.47l-1.59-.53a1.94,1.94,0,0,0-1.7.23L10,13.68Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffc455"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4,16.37H21.68l-5.52-5.51a2.26,2.26,0,0,0-.92-.57l-1.92-.65a2.38,2.38,0,0,0-2.06.28L5.13,14Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-1.11,17h20.3l-6.31-6.32a2.65,2.65,0,0,0-1.06-.65l-2.2-.74a2.74,2.74,0,0,0-2.36.32l-7,4.68Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffd25a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-9.39,18.36H17.1L8.86,10.12a3.48,3.48,0,0,0-1.38-.85l-2.87-1a3.52,3.52,0,0,0-3.07.42l-9.16,6.1Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.71,4.05H9.89L10.77.37h1.32a.93.93,0,0,1,.91.71Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.49,4.64H10.06a.5.5,0,0,1-.51-.5V4a.51.51,0,0,1,.51-.51h3.43A.5.5,0,0,1,14,4v.17a.5.5,0,0,1-.5.5Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.22,2.05l-.86-.22a.38.38,0,0,1-.21-.59l.62-.87Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.39-6.6l-.12,1A8.6,8.6,0,0,1,11.8-7a8.6,8.6,0,0,1,4.53,1.34c0-.33-.08-.65-.13-1a9.43,9.43,0,0,0-4.4-1.12A9.5,9.5,0,0,0,7.39-6.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.45-7c0,.32-.08.65-.13,1A8.64,8.64,0,0,1,11.8-7.39,8.57,8.57,0,0,1,16.27-6l-.12-1a8.94,8.94,0,0,0-8.7,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#5aa0e6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.5-7.41l-.12,1A8.23,8.23,0,0,1,11.8-7.78a8.25,8.25,0,0,1,4.42,1.34l-.12-1a9,9,0,0,0-4.3-1.13A9,9,0,0,0,7.5-7.41Zm0,0",
    transform: "translate(194 123)",
    fill: "#9bc800"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.56-7.86c0,.32-.08.65-.13,1A8.11,8.11,0,0,1,11.8-8.23a8.11,8.11,0,0,1,4.37,1.34c-.05-.32-.08-.65-.13-1A8.76,8.76,0,0,0,11.8-9,8.76,8.76,0,0,0,7.56-7.86Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe14e"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.62-8.3c0,.32-.09.65-.13,1A7.92,7.92,0,0,1,11.8-8.68a8,8,0,0,1,4.31,1.35c0-.32-.08-.65-.13-1A8.54,8.54,0,0,0,11.8-9.44,8.65,8.65,0,0,0,7.62-8.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb14e"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.64-8.49l-.09.68A7.78,7.78,0,0,1,11.8-9.16a7.75,7.75,0,0,1,4.25,1.35L16-8.49A8.46,8.46,0,0,0,11.8-9.62,8.35,8.35,0,0,0,7.64-8.49Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M36.52,24.54H-12.92a.9.9,0,0,1-.78-.47.88.88,0,0,1,0-.9L11.07-13.91a.91.91,0,0,1,1.46,0L37.25,23.17a.88.88,0,0,1,0,.9.9.9,0,0,1-.78.47Zm-47.79-1.77H34.87L11.8-11.83Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8-21.36a.88.88,0,0,1-.88-.89v-3.53a.87.87,0,0,1,.88-.88.87.87,0,0,1,.88.88v3.53a.88.88,0,0,1-.88.89Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.57-21.36H10a.89.89,0,0,1-.88-.89.88.88,0,0,1,.88-.88h3.54a.88.88,0,0,1,.88.88.89.89,0,0,1-.88.89Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,42.2a.63.63,0,0,1-.19,0c-.86-.19-3.75-.88-4.6-1.73a2.76,2.76,0,0,1,0-3.9,2.73,2.73,0,0,1,1.94-.81H9a2.73,2.73,0,0,1,2,.8c.85.85,1.56,3.72,1.76,4.58a.88.88,0,0,1-.23.82.9.9,0,0,1-.63.27ZM9,37.49a1.68,1.68,0,0,0-.7.3,1,1,0,0,0,0,1.4,8.55,8.55,0,0,0,2.32.9,8.58,8.58,0,0,0-.92-2.31l.62-.62-.62.62a1,1,0,0,0-.7-.29Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.8,42.2a.9.9,0,0,1-.63-.27.88.88,0,0,1-.23-.82c.2-.86.91-3.73,1.76-4.58a2.82,2.82,0,0,1,2-.8,2.76,2.76,0,0,1,1.93,4.71c-.85.85-3.74,1.54-4.6,1.73a.63.63,0,0,1-.19,0Zm1.52-5,.62.62A8.68,8.68,0,0,0,13,40.09a8.55,8.55,0,0,0,2.32-.9,1,1,0,0,0-.7-1.7,1,1,0,0,0-.7.29Zm0,0h0Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.27,47.49a.87.87,0,0,1-.88-.88c0-4,3.85-6,4-6.09a.88.88,0,0,1,.79,1.58s-3,1.58-3,4.51a.87.87,0,0,1-.88.88Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.33,47.49a.87.87,0,0,1-.88-.88c0-2.93-3-4.5-3-4.51a.89.89,0,1,1,.8-1.58c.16.09,4,2.06,4,6.09a.87.87,0,0,1-.88.88Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagSV;
exports["default"] = _default;